// extracted by mini-css-extract-plugin
module.exports = {"icon":"Favorite_icon_3jBX2","favoriteIcon":"Favorite_favoriteIcon_2_TXv","link":"Favorite_link_tTHcl","optionalText":"Favorite_optionalText_3FVbn"};